import type React from 'react';

// 原稿用紙グリッドセル用静的ID配列 (BiomeのnoArrayIndexKey警告を完全に回避するため)
export const gridCells = Array.from({ length: 100 }, (_, i) => ({ id: `cell-${i}` }));

// 豪華な額縁フレーム描画
export const renderFrame = (type: string, color: string, opacity: number): React.ReactNode => {
  if (!type || type === 'none') return null;
  const style: React.CSSProperties = {
    borderColor: color,
    color: color,
    opacity: opacity / 100,
  };

  if (type === 'classic-gold') {
    return (
      <div
        style={style}
        className="absolute inset-2 border-[3px] border-double pointer-events-none z-10 rounded-sm"
      >
        <div
          style={{ borderColor: color }}
          className="absolute inset-0.5 border pointer-events-none"
        />
      </div>
    );
  }
  if (type === 'fancy-border') {
    return (
      <div style={style} className="absolute inset-2 border pointer-events-none z-10 rounded-sm">
        <svg
          aria-hidden="true"
          viewBox="0 0 100 100"
          fill="currentColor"
          className="absolute top-0 left-0 w-6 h-6"
        >
          <path d="M2,2 L15,2 C15,2 10,4 4,4 L4,15 C4,15 2,10 2,2 Z M2,2 C10,2 10,10 2,10 Z" />
        </svg>
        <svg
          aria-hidden="true"
          viewBox="0 0 100 100"
          fill="currentColor"
          className="absolute top-0 right-0 w-6 h-6 rotate-90"
        >
          <path d="M2,2 L15,2 C15,2 10,4 4,4 L4,15 C4,15 2,10 2,2 Z M2,2 C10,2 10,10 2,10 Z" />
        </svg>
        <svg
          aria-hidden="true"
          viewBox="0 0 100 100"
          fill="currentColor"
          className="absolute bottom-0 left-0 w-6 h-6 -rotate-90"
        >
          <path d="M2,2 L15,2 C15,2 10,4 4,4 L4,15 C4,15 2,10 2,2 Z M2,2 C10,2 10,10 2,10 Z" />
        </svg>
        <svg
          aria-hidden="true"
          viewBox="0 0 100 100"
          fill="currentColor"
          className="absolute bottom-0 right-0 w-6 h-6 rotate-180"
        >
          <path d="M2,2 L15,2 C15,2 10,4 4,4 L4,15 C4,15 2,10 2,2 Z M2,2 C10,2 10,10 2,10 Z" />
        </svg>
      </div>
    );
  }
  if (type === 'japanese-border') {
    return (
      <div
        style={style}
        className="absolute inset-0 pointer-events-none z-10 flex flex-col justify-between py-2 px-3"
      >
        <div
          style={{
            backgroundImage: `repeating-linear-gradient(90deg, ${color}, ${color} 8px, transparent 8px, transparent 16px)`,
          }}
          className="h-1.5 w-full opacity-80"
        />
        <div
          style={{
            backgroundImage: `repeating-linear-gradient(90deg, ${color}, ${color} 8px, transparent 8px, transparent 16px)`,
          }}
          className="h-1.5 w-full opacity-80"
        />
      </div>
    );
  }
  if (type === 'cyber-frame') {
    return (
      <div style={style} className="absolute inset-2 pointer-events-none z-10">
        <div
          style={{ borderColor: color }}
          className="absolute top-0 left-0 w-4 h-4 border-t-2 border-l-2"
        />
        <div
          style={{ borderColor: color }}
          className="absolute top-0 right-0 w-4 h-4 border-t-2 border-r-2"
        />
        <div
          style={{ borderColor: color }}
          className="absolute bottom-0 left-0 w-4 h-4 border-b-2 border-l-2"
        />
        <div
          style={{ borderColor: color }}
          className="absolute bottom-0 right-0 w-4 h-4 border-b-2 border-r-2"
        />
        <div
          style={{ borderColor: color }}
          className="absolute top-2 bottom-2 left-0 border-l border-dashed opacity-30"
        />
        <div
          style={{ borderColor: color }}
          className="absolute top-2 bottom-2 right-0 border-r border-dashed opacity-30"
        />
      </div>
    );
  }
  if (type === 'manuscript') {
    return (
      <div
        style={{ borderColor: color, opacity: (opacity / 100) * 0.35 }}
        className="absolute inset-3 border pointer-events-none z-10 flex flex-col justify-between p-1"
      >
        <div
          className="grid grid-cols-10 grid-rows-10 w-full h-full border border-collapse"
          style={{ borderColor: color }}
        >
          {gridCells.map((cell) => (
            <div
              key={cell.id}
              className="border border-collapse opacity-30"
              style={{ borderColor: color }}
            />
          ))}
        </div>
      </div>
    );
  }
  return null;
};
